/**
 * Pending Approval Page (Web)
 * Displayed when user is authenticated but not yet approved by admin
 */

import React, { useState } from 'react';
import {
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBTypography,
  MDBBtn,
  MDBSpinner,
} from 'mdb-react-ui-kit';
import { useAuth } from '../contexts/AuthContext';
import './PendingApproval.css';

const PendingApproval: React.FC = () => {
  const { user, signOut, approvalStatus, checkApprovalStatus } = useAuth();
  const [checking, setChecking] = useState(false);

  const handleCheckStatus = async () => {
    setChecking(true);
    try {
      await checkApprovalStatus();
    } catch (error) {
      console.error('[PendingApproval] Error checking status:', error);
    } finally {
      setChecking(false);
    }
  };

  const isPending = approvalStatus === 'pending';
  const isRejected = approvalStatus === 'rejected';

  return (
    <div className="pending-approval-page">
      <MDBContainer className="py-5">
        <div className="d-flex justify-content-center">
          <MDBCard className="pending-approval-card">
            <MDBCardBody className="text-center p-5">
              <div className="icon-container mb-4">
                {isPending ? (
                  <i className="fas fa-clock fa-4x text-warning"></i>
                ) : (
                  <i className="fas fa-times-circle fa-4x text-danger"></i>
                )}
              </div>

              <MDBTypography tag="h4" className="mb-4">
                {isPending
                  ? 'Account Pending Approval'
                  : 'Account Access Denied'}
              </MDBTypography>

              <p className="text-muted mb-4">
                {isPending
                  ? 'Your account is waiting for administrator approval. You will be able to access the app once your account has been approved.'
                  : 'Your account access has been denied by an administrator.'}
              </p>

              {isRejected && user?.rejectionReason && (
                <div className="alert alert-danger mb-4">
                  <strong>Reason:</strong> {user.rejectionReason}
                </div>
              )}

              {user?.email && (
                <p className="text-muted small mb-4">
                  <em>Signed in as: {user.email}</em>
                </p>
              )}

              <div className="d-grid gap-3">
                <MDBBtn
                  color="primary"
                  onClick={handleCheckStatus}
                  disabled={checking}
                >
                  {checking ? (
                    <>
                      <MDBSpinner size="sm" className="me-2" />
                      Checking...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-refresh me-2"></i>
                      Check Status
                    </>
                  )}
                </MDBBtn>

                <MDBBtn color="secondary" outline onClick={signOut}>
                  <i className="fas fa-sign-out-alt me-2"></i>
                  Sign Out
                </MDBBtn>
              </div>
            </MDBCardBody>
          </MDBCard>
        </div>
      </MDBContainer>
    </div>
  );
};

export default PendingApproval;
